<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="frmbbxx">
        <!-- <div class="loader"></div> -->
        <app-main-heading [title]="this.formTitle"></app-main-heading>
        <div class="productPoup1">
            <div class="row">
                <div class="col-lg-4">
                    <div class="inputGroupPlan">
                        <label for="productName" class="inputLabelPlan text-black popInLabel">Product Name</label>
                        <input maxlength="64" type="text"
                            formControlName="productName"
                            class="inputBox {{form.get('productName')?.errors && form.get('productName')?.touched ? 'border-danger' : ''}}"
                            id="productName" placeholder="Enter Product Name" />
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('productName')?.hasError('required') && form.get('productName')?.touched">
                            Product Name is required.
                        </small>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('productName')?.hasError('maxlength') && form.get('productName')?.touched">
                            Product name can't be more than
                            {{form.get('productName')?.errors?.['maxlength']?.requiredLength}} chars.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroupPlan">
                        <mat-label class="matLabel text-black">Category </mat-label>
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-select formControlName="categoryId" placeholder="Select Category" >
                                <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let category of categoryList.response" [value]="category.id">
                                    {{ category.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched">
                            Category is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroupPlan">
                        <mat-label class="matLabel text-black">Sub Category </mat-label>
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-select formControlName="subCategoryId" placeholder="Select Sub Category">
                                <mat-option [value]="" *ngIf="subCategoryList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let subCategory of subCategoryList.response"
                                    [value]="subCategory.id">
                                    {{ subCategory.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched">
                            Sub Category is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="inputGroupPlan">
                        <label for="addreg" class="inputLabelPlan text-black popInLabel">Product Description</label>
                        <textarea id="addreg" formControlName="description" maxlength="80"
                            class="{{form.get('description')?.errors && form.get('description')?.touched ? 'border-danger' : ''}}"
                            placeholder="Enter Product Description" class="inputBox regTextarea prodModelAreaheight addhtt"></textarea>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched">
                            Description is required.
                        </small>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('description')?.hasError('maxlength') && form.get('description')?.touched">
                            Description can't be more than
                            {{form.get('description')?.errors?.['maxlength']?.requiredLength}} chars.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="inputGroupPlan">
                                <mat-label class="matLabel text-black">Available Branches </mat-label>
                                <mat-form-field
                                    class="w-100 mat-input-group {{form.get('availableBranches')?.hasError('required') && form.get('availableBranches')?.touched ? 'border-danger' : ''}}"
                                    appearance="outline">
                                    <mat-select formControlName="availableBranches" multiple placeholder="Select Branches">
                                        <mat-option [value]="" *ngIf="availableBranches.loading"><i>Loading
                                                ...</i></mat-option>
                                        <!-- <mat-option [value]=null *ngIf="!availableBranches.loading">All branches</mat-option> -->
                                        <mat-option *ngFor="let ab of availableBranches.response" [value]="{id:ab.id}">
                                            <!-- {{ ab.branchName }} {{ ab.address }}, {{ ab.city }}, {{ ab.state }}, {{
                                            ab.pincode }} -->
                                            {{ab.branchName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <small class="text-danger errorFixed"
                                    *ngIf="form.get('availableBranches')?.hasError('required') && form.get('availableBranches')?.touched">
                                    Available Branches is required.
                                </small>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="inputGroupPlan">
                                        <label for="weight" class="inputLabelPlan text-black popInLabel">
                                            Weight (Grams)
                                        </label>
                                        <input (keypress)="this.allowOnlyNumeric($event)" type="tel"
                                            formControlName="weight" maxlength="6"
                                            class="inputBox {{form.get('weight')?.hasError('required') && form.get('weight')?.touched ? 'border-danger' : ''}}"
                                            id="weight" placeholder="Enter Weight" />
                                        
                                        <small class="text-danger errorFixed"
                                            *ngIf="form.get('weight')?.hasError('required') && form.get('weight')?.touched">
                                            Weight is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="inputGroupPlan">
                                        <mat-label class="matLabel text-black">Weight Unit </mat-label>
                                        <mat-form-field
                                            class="w-100 mat-input-group {{form.get('weightUnitId')?.hasError('required') && form.get('weightUnitId')?.touched ? 'border-danger' : ''}}"
                                            appearance="outline">
                                            <mat-select formControlName="weightUnitId" placeholder="Select Weight Unit">
                                                <mat-option *ngFor="let weightUnitId of weightUnitList.response"
                                                    [value]="weightUnitId.id">
                                                    {{ weightUnitId.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <small class="text-danger errorFixed"
                                            *ngIf="form.get('weightUnitId')?.hasError('required') && form.get('weightUnitId')?.touched">
                                            Weight unit is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroupPlan">
                        <mat-label class="matLabel text-black">Del. Distance </mat-label>
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('delDistanceId')?.hasError('required') && form.get('delDistanceId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-select formControlName="delDistanceId" placeholder="Select Del. Distance">
                                <mat-option [value]="" *ngIf="delDistanceList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let delDistanceId of delDistanceList.response"
                                    [value]="delDistanceId.id">
                                    {{ delDistanceId.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('delDistanceId')?.hasError('required') && form.get('delDistanceId')?.touched">
                            Del. distance is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroupPlan">
                        <mat-label class="matLabel text-black">Product Type </mat-label>
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('productTypeId')?.hasError('required') && form.get('productTypeId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-select formControlName="productTypeId" placeholder="Select Product Type">
                                <mat-option [value]="" *ngIf="prodTypeList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let productTypeId of prodTypeList.response"
                                    [value]="productTypeId.id">
                                    {{ productTypeId.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('productTypeId')?.hasError('required') && form.get('productTypeId')?.touched">
                            Product type is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroupPlan">
                        <mat-label class="matLabel text-black">Packing Type </mat-label>
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('packingTypeId')?.hasError('required') && form.get('packingTypeId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-select formControlName="packingTypeId" placeholder="Select Packing Type">
                                <mat-option [value]="" *ngIf="packingTypeList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let packingTypeId of packingTypeList.response"
                                    [value]="packingTypeId.id">
                                    {{ packingTypeId.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger errorFixed"
                            *ngIf="form.get('packingTypeId')?.hasError('required') && form.get('packingTypeId')?.touched">
                            Packing type is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="imgUploadTitle">Upload Product photo</div>
                    <div class="imageUploadSec">

                        <div class="imageUpload me-2" *ngFor="let ml of mediaList?.value; index as k">
                            <label formArrayName="mediaList" for="ml{{k}}"
                                class="border {{!ml?.src && k === 0 && form.get('mediaList')?.touched ? 'border-danger' : ''}}">
                                <input hidden *ngIf="!this.uploadingFile" type="file" id="ml{{k}}"
                                    accept=".png,.jpg,.jpeg" (input)="this.uploadFile($event.target, 'media', k)" />
                                <img src="{{ml?.src}}" *ngIf="!(this.uploadingMediaIndex === k && this.uploadingFile)"
                                    onerror="this.src = '../../../assets/images/upload-img.svg';" alt=""
                                    style="height: 110px;" />
                                <div *ngIf="this.uploadingMediaIndex === k">
                                    <div class="loader"></div>
                                </div>
                            </label>
                            <button class="action" *ngIf="ml?.src" (click)="this.removeMedia(k)">
                                <img src="./assets/images/trash-icon.svg" alt="" />
                            </button>
                        </div>

                    </div>
                    <div class="imgUploadText">
                        *Recommended resolution is 640×640 with file size {{this.allowedFileSizeToUpload}} MB
                    </div>
                </div>
                <div class="tablebox">
                    <div class="text-center" *ngIf="this.subCategoryVarientList.loading">
                        <div class="loader"></div>
                    </div>
                    <div class="addBlockpr customScroll" formArrayName="variantList"
                        *ngIf="this.subCategoryVarientList.response?.length">
                        <div class="addBlockprHead">
                            <div class="hedItm">S. No</div>
                            <div class="hedItm">SKU OR BARCODE or Variant name</div>
                            <div class="hedItm">Quantity</div>
                            <div class="hedItm">Stock Status</div>
                            <div class="hedItm">Status</div>
                            <div class="hedItm" *ngFor="let vt of this.subCategoryVarientList.response; index as in">
                                Attribute {{in+1}}</div>
                            <div class="hedItm">MRP</div>
                            <div class="hedItm">Discounted Price</div>
                            <div class="hedItm">Variant photo</div>
                            <div class="hedItm">Delete</div>
                        </div>
                        <div class="addrecRow" *ngFor="let variant of variantControls; index as i">
                            <div class="addrecItm" [formGroupName]="i">{{i+1}}</div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="inputGroup w-100">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="text" formControlName="sku"
                                        maxlength="19"
                                        class="inputBox {{variant.get('sku')?.errors && variant.get('sku')?.touched ? 'border-danger' :''}}"
                                        id="sku{{i}}" placeholder="" />
                                    <label for="sku{{i}}" class="inputLabel popInLabel">
                                        SKU OR BARCODE
                                    </label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('sku')?.hasError('required') && variant.get('sku')?.touched">
                                        SKU is required.
                                    </small>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="tel"
                                        formControlName="quantity" maxlength="4"
                                        class="inputBox {{variant.get('quantity')?.errors && variant.get('quantity')?.touched ? 'border-danger' :''}}"
                                        id="quantity{{i}}" placeholder="" />
                                    <label for="quantity{{i}}" class="inputLabel popInLabel">Quantity</label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('quantity')?.hasError('required') && variant.get('quantity')?.touched">
                                        Quantity is required.
                                    </small>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="inputGroup">
                                    <mat-form-field
                                        class="w-100 mat-input-group {{variant.get('stockStatusId')?.errors && variant.get('stockStatusId')?.touched ? 'border-danger' :''}}"
                                        appearance="outline">
                                        <mat-label class="matLabel text-black">Stock
                                            Status </mat-label>
                                        <mat-select formControlName="stockStatusId">
                                            <mat-option *ngFor="let stockStatus of stockStatusList.response"
                                                [value]="stockStatus.id">
                                                {{ stockStatus.status }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('stockStatusId')?.hasError('required') && variant.get('stockStatusId')?.touched">
                                        Stock status is required.
                                    </small>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="inputGroup">
                                    <mat-form-field
                                        class="w-100 mat-input-group {{variant.get('statusId')?.errors && variant.get('statusId')?.touched ? 'border-danger' :''}}"
                                        appearance="outline">
                                        <mat-label class="matLabel text-black">Status </mat-label>
                                        <mat-select formControlName="statusId">
                                            <mat-option *ngFor="let status of statusList.response" [value]="status.id">
                                                {{ status.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('statusId')?.hasError('required') && variant.get('statusId')?.touched">
                                        Status is required.
                                    </small>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i"
                                *ngFor="let vt of this.subCategoryVarientList.response; index as in">
                                <div class="inputGroup">
                                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                                        <mat-label class="matLabel text-black">{{vt.name}} </mat-label>
                                        <mat-select formControlName="variantOption{{in+1}}">
                                            <mat-option *ngFor="let vo of vt.options; index as in"
                                                [value]="vo.variant_option_value">{{vo.variant_option_value}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="tel" formControlName="price"
                                        maxlength="6"
                                        class="inputBox {{variant.get('price')?.errors && variant.get('price')?.touched ? 'border-danger' : ''}}"
                                        id="price{{i}}" placeholder="" />
                                    <label for="price{{i}}" class="inputLabel popInLabel">MRP
                                    </label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('price')?.hasError('required') && variant.get('price')?.touched">
                                        Price is required.
                                    </small>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="tel" maxlength="6"
                                        formControlName="discountedPrice"
                                        class="inputBox {{variant.get('discountedPrice')?.errors && variant.get('discountedPrice')?.touched ? 'border-danger' : ''}}"
                                        id="discountedPrice{{i}}" placeholder="" style="width: 200px;" />
                                    <label for="discountedPrice{{i}}" class="inputLabel popInLabel">Discounted
                                        Price</label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('discountedPrice')?.hasError('required') && variant.get('discountedPrice')?.touched">
                                        Discounted price is required.
                                    </small>
                                </div>
                            </div>
                            <div class="addrecItm" [formGroupName]="i">
                                <div class="position-relative"
                                    *ngFor="let vm of variant.get('mediaList')?.value; index as j">
                                    <label formArrayName="mediaList" for="media{{i}}">
                                        <input hidden *ngIf="!this.uploadingFile" type="file" id="media{{i}}"
                                            accept=".png,.jpg,.jpeg"
                                            (input)="this.uploadFile($event.target, 'varient', i)" />
                                        <img src="{{vm?.src}}"
                                            *ngIf="!(this.uploadingVarientMediaIndex === i && this.uploadingFile)"
                                            onerror="this.src = '../../../assets/images/upload-img.svg';" alt=""
                                            style="height: 110px;" />
                                        <div *ngIf="this.uploadingVarientMediaIndex === i">
                                            <div class="loader"></div>
                                        </div>
                                    </label>
                                    <button class="action" *ngIf="vm?.src" (click)="this.removeVariantMedia(i,j)">
                                        <img src="./assets/images/trash-icon.svg" alt="" />
                                    </button>
                                </div>
                            </div>
                            <div class="addrecItm">
                                <button class="action" (click)="this.removeVariant(i)">
                                    <img src="./assets/images/trash-icon.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="aabtn d-block text-start mt-4" *ngIf="this.subCategoryVarientList.response?.length">
                    <span class="btnTextPluse cursor-pointer" (click)="this.addVariant()">+ Add another option</span>
                </div>
            </div>
        </div>
        <div class="text-center d-block mb-2">
            <div class="btnbx modPopBtns mt-3">
                <button type="button" class="btnThemeOutline blue me-3 modelPopup-btn"
                    [disabled]="this.submitLoading || this.uploadingFile" (click)="this.handleReset()">
                    Cancel
                </button>
                <button class="gredientOutLineBtn" [disabled]="this.submitLoading || this.uploadingFile">
                    <!-- <div class="loader" *ngIf="this.submitLoading"></div>
                    <div class="btnContent modelPopup-btn" *ngIf="!this.submitLoading">Add New Product </div> -->
                    <div class="btnContent modelPopup-btn">
                        <div class="loader small" *ngIf="this.submitLoading"></div>
                        <div *ngIf="!this.submitLoading">Add New Product</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</form>